import { useEffect } from 'react';
import { initGA, trackPageView, trackScrollDepth, trackButtonClick } from '../utils/analytics';

export const useAnalytics = () => {
  useEffect(() => {
    // Initialize GA4
    if (typeof window !== 'undefined') {
      initGA();
    }
  }, []);

  useEffect(() => {
    // Track page view on mount
    if (typeof window !== 'undefined') {
      trackPageView(window.location.pathname, document.title);
    }
  }, []);

  useEffect(() => {
    // Track scroll depth
    let maxScrollDepth = 0;
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      const scrollPercent = Math.round((scrollTop / (documentHeight - windowHeight)) * 100);
      
      // Track milestones: 25%, 50%, 75%, 100%
      if (scrollPercent >= 25 && maxScrollDepth < 25) {
        maxScrollDepth = 25;
        trackScrollDepth(25);
      } else if (scrollPercent >= 50 && maxScrollDepth < 50) {
        maxScrollDepth = 50;
        trackScrollDepth(50);
      } else if (scrollPercent >= 75 && maxScrollDepth < 75) {
        maxScrollDepth = 75;
        trackScrollDepth(75);
      } else if (scrollPercent >= 100 && maxScrollDepth < 100) {
        maxScrollDepth = 100;
        trackScrollDepth(100);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return {
    trackButtonClick,
  };
};
